import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";

import { AppLayout } from "../components/appLayout";
import { VideoAddEditForm } from "../components/forms/videoAddEditForm";
import useApiClient from "../hooks/useApiClient";
import { CategoryWithCountsViewModel } from "../apiClient";

export const VideoAdd = () => {
    const apiClient = useApiClient();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const initialUrl = searchParams.get('url') ?? undefined;
    const [categories, setCategories] = useState<CategoryWithCountsViewModel[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!apiClient) return;

        const loadData = async () => {
            const categories = await apiClient.categoriesAll();
            setCategories(categories);
            setLoading(false);
        };

        loadData();
    }, [apiClient]);

    return (
        <AppLayout loading={loading}>
            <Container className="py-2">
                <Breadcrumb>
                    <LinkContainer to={`/`}>
                        <Breadcrumb.Item>Videos</Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>Add video</Breadcrumb.Item>
                </Breadcrumb>

                <div className="mb-3">
                    <h1 className="mb-1">Add video</h1>
                    <p className="text-body-secondary mb-0">
                        Paste a video URL to resolve its title and add it to your library.
                    </p>
                </div>

                <Card>
                    <Card.Body className="p-4">
                        <VideoAddEditForm
                            apiClient={apiClient!}
                            initialUrl={initialUrl}
                            categories={categories}
                            onSave={() => navigate(`/`)}
                        />
                    </Card.Body>
                </Card>
            </Container>
        </AppLayout>
    );
};